import { render, staticRenderFns } from "./ButtonLogout.vue?vue&type=template&id=5539d142&"
import script from "./ButtonLogout.vue?vue&type=script&lang=js&"
export * from "./ButtonLogout.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLogout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports